module.exports = __webpack_public_path__ + "static/img/1-8.4c183290.png";